// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExecutedCollateralTransfer } from '../../../hooks/queries/collateral/collateral/useExecutedCollateralTransfer';
import useInstructedCollateral from '../../../hooks/queries/collateral/collateral/useInstructedCollateral';
import { InstructedRow } from './types';

export const useGetCollateralRows = () => {
  const instructedCollateral = useInstructedCollateral();
  const executedTransfer = useExecutedCollateralTransfer();

  const settledRows: InstructedRow[] = (executedTransfer?.data || []).map((i) => ({
    contractId: i.contractId,
    payload: {
      agreementId: i.payload.agreementId,
      partyA: i.payload.partyA,
      partyB: i.payload.partyB,
      id: i.payload.id,
      positions: i.payload.settledPositions,
      createdAt: i.createdAt,
      instructId: i.payload.id,
    },
    state: 'Settled',
  }));

  const instructedRows: InstructedRow[] = (instructedCollateral?.data || []).map((i) => ({
    contractId: i.contractId,
    payload: {
      agreementId: i.payload.agreementId,
      partyA: i.payload.partyA,
      partyB: i.payload.partyB,
      id: i.payload.id,
      positions: i.payload.instructedPositions,
      createdAt: i.createdAt,
      allocateBefore: i.payload.allocateBefore,
      settleBefore: i.payload.settleBefore,
      instructId: i.payload.id,
    },
    state: 'Instructed',
  }));

  const sortedRows = [...instructedRows, ...settledRows].sort(
    (a, b) => new Date(b.payload.createdAt).getTime() - new Date(a.payload.createdAt).getTime(),
  );

  return { rows: sortedRows };
};
